export default `
  <div class="robo_image"></div>
  <p class="robo_message"></p>
`;
